export default __webpack_public_path__ + "static/img9-1f754ce378a7c59734958b573dd6fa42.png";